export default __webpack_public_path__ + "static/tabs-hierarchy-do-03824fe8fe7281b0c96ac72be55f4ddba73527b11dd8d0309ece00c2e2ce1868.png";